import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
.access-page {
  min-height: 100vh;
  min-height: 100dvh;
  padding: 32px;
  color: #0f172a;
  background: radial-gradient(circle at 16% 18%, rgba(124, 58, 237, 0.14), transparent 30%), radial-gradient(circle at 88% 12%, rgba(225, 29, 72, 0.12), transparent 24%), linear-gradient(135deg, #fbf9ff 0%, #fff1f4 48%, #fbf9ff 100%);
}

.access-shell {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(360px, 430px);
  gap: 44px;
  align-items: center;
  width: min(1240px, 100%);
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
  margin: 0 auto;
}

.access-visual {
  position: relative;
  min-height: 780px;
  padding: 52px 0 34px;
}

.brand-row,
.mobile-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #7c3aed;
  font-size: 20px;
  font-weight: 900;
}

.brand-mark {
  position: relative;
  width: 30px;
  height: 30px;
  color: #7c3aed;
}

.brand-mark span {
  position: absolute;
  width: 12px;
  height: 12px;
  border: 2px solid currentColor;
  border-radius: 999px;
}

.brand-mark span:nth-child(1) {
  top: 0;
  left: 3px;
}

.brand-mark span:nth-child(2) {
  top: 3px;
  right: 0;
}

.brand-mark span:nth-child(3) {
  right: 3px;
  bottom: 0;
}

.brand-mark span:nth-child(4) {
  bottom: 3px;
  left: 0;
}

.visual-copy {
  max-width: 520px;
  margin-top: 34px;
}

.eyebrow {
  margin: 0 0 10px;
  color: #e11d48;
  font-size: 12px;
  font-weight: 900;
  text-transform: uppercase;
}

.visual-copy h1 {
  margin: 0;
  color: #0f172a;
  font-size: 50px;
  font-weight: 900;
  line-height: 1.12;
  letter-spacing: 0;
}

.visual-copy p:last-child {
  max-width: 400px;
  margin: 22px 0 0;
  color: #64748b;
  font-size: 16px;
  line-height: 1.8;
}

.schedule-preview {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 30px;
  display: grid;
  grid-template-rows: 46px minmax(0, 1fr);
  height: 420px;
  overflow: visible;
  border: 1px solid rgba(148, 163, 184, 0.3);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 26px 64px rgba(15, 23, 42, 0.14);
}

.preview-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
  border-bottom: 1px solid #e2e8f0;
  background: rgba(248, 251, 255, 0.96);
}

.preview-topbar div {
  display: flex;
  gap: 6px;
}

.preview-topbar div span {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #cbd5e1;
}

.preview-topbar strong {
  color: #1e293b;
  font-size: 14px;
  font-weight: 900;
}

.preview-topbar em {
  padding: 5px 10px;
  border-radius: 999px;
  color: #7c3aed;
  font-size: 12px;
  font-style: normal;
  font-weight: 900;
  background: #f3e8ff;
}

.preview-body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 180px;
  min-height: 0;
}

.calendar-panel {
  min-height: 0;
  padding: 22px 24px;
  background: linear-gradient(#edf2f7 1px, transparent 1px) 0 66px/100% 52px, linear-gradient(90deg, #edf2f7 1px, transparent 1px) 0 0/20% 100%, #fff;
}

.calendar-head,
.calendar-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
}

.calendar-head span {
  color: #94a3b8;
  font-size: 11px;
  font-weight: 900;
  text-align: center;
}

.calendar-grid {
  margin-top: 14px;
}

.calendar-grid > div {
  min-height: 46px;
  border-radius: 6px;
}

.event {
  display: flex;
  align-items: center;
  padding: 0 10px;
  overflow: hidden;
  color: #1e293b;
  font-size: 11px;
  font-weight: 900;
  white-space: nowrap;
}

.event.blue {
  background: #f3e8ff;
}

.event.green {
  background: #dcfce7;
}

.event.orange {
  background: #ffedd5;
}

.event.purple {
  background: #ede9fe;
}

.event.wide {
  grid-column: span 2;
}

.phone-preview {
  align-self: center;
  justify-self: center;
  width: 168px;
  height: 322px;
  padding: 4px;
  border: 2px solid rgba(15, 23, 42, 0.88);
  border-radius: 31px;
  background: #0f172a;
  box-shadow: 0 22px 36px rgba(15, 23, 42, 0.18);
}

.phone-screen {
  height: 100%;
  padding: 10px 10px 12px;
  overflow: hidden;
  border-radius: 26px;
  background: #fff;
}

.phone-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 18px;
  color: #0f172a;
  font-size: 9px;
  font-weight: 900;
}

.phone-status i {
  width: 34px;
  height: 8px;
  border-radius: 999px;
  background: #111827;
}

.phone-title {
  margin: 10px 0 12px;
}

.phone-title small {
  display: block;
  margin-bottom: 2px;
  color: #e11d48;
  font-size: 9px;
  font-weight: 900;
}

.phone-title strong {
  display: block;
  color: #0f172a;
  font-size: 16px;
  line-height: 1.2;
}

.phone-days {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 5px;
  margin-bottom: 10px;
}

.phone-days span {
  display: grid;
  place-items: center;
  height: 28px;
  border-radius: 8px;
  color: #475569;
  font-size: 9px;
  font-weight: 900;
  background: #f1f5f9;
}

.phone-item {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  gap: 8px;
  padding: 10px;
  margin-bottom: 8px;
  border-radius: 8px;
}

.phone-item.green {
  background: #ecfdf5;
}

.phone-item.orange {
  background: #fff7ed;
}

.phone-item.blue {
  background: #f5f3ff;
}

.phone-item > span {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: #34d399;
}

.phone-item.orange > span {
  background: #fb923c;
}

.phone-item.blue > span {
  background: #8b5cf6;
}

.phone-item b {
  display: block;
  color: #0f172a;
  font-size: 11px;
}

.phone-item small {
  color: #64748b;
  font-size: 9px;
}

.phone-nav {
  display: flex;
  justify-content: space-around;
  margin-top: 14px;
}

.phone-nav span {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #ddd6fe;
}

.access-auth {
  display: flex;
  justify-content: center;
}

.login-card {
  width: 100%;
  padding: 36px;
  border: 1px solid rgba(203, 213, 225, 0.78);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);
}

.mobile-brand {
  display: none;
  margin-bottom: 24px;
}

.login-card h2 {
  margin: 0;
  color: #0f172a;
  font-size: 25px;
  font-weight: 900;
}

.login-desc {
  margin: 9px 0 28px;
  color: #64748b;
  font-size: 13px;
}

.form-stack {
  display: grid;
  gap: 16px;
}

.form-stack label,
.label-row label {
  display: block;
  margin-bottom: 8px;
  color: #334155;
  font-size: 13px;
  font-weight: 800;
}

.label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.label-row label {
  margin: 0;
}

.label-row a {
  color: #7c3aed;
  font-size: 12px;
  font-weight: 800;
  text-decoration: none;
}

.form-stack .identifier-input,
.password-field input {
  box-sizing: border-box;
  width: 100%;
  height: 46px;
  border: 1px solid #dbe3ef;
  border-radius: 6px;
  background: #fff;
  color: #0f172a;
  font-size: 13px;
  outline: none;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.form-stack .identifier-input {
  padding: 0 14px;
}

.password-field {
  position: relative;
}

.password-field input {
  padding: 0 42px 0 14px;
}

.password-field svg {
  position: absolute;
  top: 50%;
  right: 14px;
  width: 18px;
  height: 18px;
  color: #94a3b8;
  transform: translateY(-50%);
}

.form-stack input:focus {
  border-color: #8b5cf6;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.16);
}

.keep-login {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  margin: 2px 0 0 !important;
  color: #475569 !important;
  font-size: 13px !important;
  font-weight: 600 !important;
}

.keep-login input {
  width: 15px;
  height: 15px;
  border-color: #cbd5e1;
  border-radius: 4px;
}

.primary-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  border: 0;
  border-radius: 6px;
  color: #fff;
  font-size: 13px;
  font-weight: 900;
  background: linear-gradient(135deg, #7c3aed, #e11d48);
  box-shadow: 0 14px 28px rgba(124, 58, 237, 0.26);
  transition: transform 160ms ease, box-shadow 160ms ease;
}

.primary-action:hover {
  transform: translateY(-1px);
  box-shadow: 0 18px 34px rgba(225, 29, 72, 0.28);
}

.account-login-list {
  margin-top: 22px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
}

.account-list-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.account-list-head span {
  color: #0f172a;
  font-size: 13px;
  font-weight: 900;
}

.account-list-head small {
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-align: right;
}

.account-list {
  display: grid;
  gap: 8px;
}

.account-button {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  width: 100%;
  min-height: 58px;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  transition: border-color 160ms ease, background 160ms ease, transform 160ms ease;
}

.account-button:hover {
  border-color: #c4b5fd;
  background: #fbfaff;
  transform: translateY(-1px);
}

.account-button:disabled {
  cursor: wait;
  opacity: 0.58;
  transform: none;
}

.account-avatar {
  display: grid;
  overflow: hidden;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  color: #0369a1;
  font-size: 13px;
  font-weight: 900;
  background: #e0f2fe;
}

.account-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.account-avatar.admin {
  color: #7c2d12;
  background: #ffedd5;
}

.account-meta {
  min-width: 0;
  text-align: left;
}

.account-meta strong,
.account-meta small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-meta strong {
  color: #0f172a;
  font-size: 13px;
  font-weight: 900;
}

.account-meta small {
  margin-top: 3px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.account-button em {
  padding: 5px 8px;
  border-radius: 999px;
  color: #475569;
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
  background: #f1f5f9;
}

.join-copy {
  margin: 24px 0 0;
  color: #64748b;
  font-size: 13px;
  text-align: center;
}

.join-copy a {
  margin-left: 8px;
  color: #7c3aed;
  font-weight: 900;
  text-decoration: none;
}

@media (max-width: 1100px) {
  .access-shell {
    grid-template-columns: 1fr;
    width: min(680px, 100%);
  }
  .access-visual {
    min-height: auto;
    padding: 20px 0 0;
  }
  .visual-copy {
    margin-top: 28px;
  }
  .schedule-preview {
    position: relative;
    left: auto;
    right: auto;
    bottom: auto;
    margin-top: 32px;
    height: 360px;
  }
  .preview-body {
    grid-template-columns: 1fr;
  }
  .phone-preview {
    display: none;
  }
}
@media (max-width: 640px) {
  .access-page {
    padding: max(22px, env(safe-area-inset-top)) max(18px, env(safe-area-inset-right)) max(26px, env(safe-area-inset-bottom)) max(18px, env(safe-area-inset-left));
  }
  .brand-row {
    display: none;
  }
  .mobile-brand {
    display: inline-flex;
  }
  .visual-copy {
    margin-top: 0;
    text-align: center;
  }
  .visual-copy h1 {
    font-size: 34px;
  }
  .visual-copy p:last-child {
    margin-left: auto;
    margin-right: auto;
    font-size: 14px;
  }
  .schedule-preview {
    display: none;
  }
  .login-card {
    padding: 28px 22px;
  }
  .account-list-head {
    display: block;
  }
  .account-list-head small {
    display: block;
    margin-top: 4px;
    text-align: left;
  }
  .account-button {
    grid-template-columns: 34px minmax(0, 1fr);
  }
  .account-button em {
    justify-self: start;
    grid-column: 2;
    margin-top: -3px;
  }
}
@media (max-width: 360px) {
  .visual-copy h1 {
    font-size: 30px;
  }
  .visual-copy p:last-child {
    font-size: 13px;
  }
  .login-card {
    padding: 24px 17px;
  }
  .login-card h2 {
    font-size: 23px;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public view: string = 'login';

    public data: any = {
        email: '',
        password: ''
    };
    public loginAccounts: any[] = [];
    public quickLoginLoading: string = '';

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) return location.href = "/";
        await this.loadLoginAccounts();
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async loadLoginAccounts() {
        let { code, data } = await wiz.call("accounts");
        if (code == 200) {
            this.loginAccounts = data.accounts || [];
            await this.service.render();
        }
    }

    public roleText(role: string) {
        if (role === 'admin') return '관리자';
        return '사용자';
    }

    public async quickLogin(account: any) {
        if (!account?.email || this.quickLoginLoading) return;

        this.quickLoginLoading = account.email;
        await this.service.render();

        let { code, data } = await wiz.call("quick_login", { email: account.email });
        if (code == 200) {
            location.href = "/";
            return;
        }

        this.quickLoginLoading = '';
        await this.alert(data.message || "계정 로그인에 실패했습니다.", 'error');
        await this.service.render();
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.data));
        if (!user.email) {
            await this.alert("이메일을 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        // user.password = this.service.auth.hash(user.password);

        let { code, data } = await wiz.call("login", user);

        if (code == 200) {
            location.href = "/";
            await this.service.render();
        } else {
            await this.alert(data.message || "로그인에 실패했습니다.", 'error');
        }
    }
}

export default PageAccessComponent;